class VUVConfigurator extends HTMLElement {
  constructor() {
    super();

    this.btnAdd = document.querySelector('.configurator-btn');
    this.btnAdd.addEventListener('click', this.addToCart);
    this.cartForm = this.querySelector("form[action='/cart']");
    this.cartForm.addEventListener("submit", (e) => {
      e.preventDefault();
    })
  }

  async addToCart() {
    let formData = {
      items: []
    };

    const currentVariants = document.querySelector("product-config").getCurrentSelectedVariants();
    const currentVariantIds = currentVariants.map(variant => variant.id);


    currentVariantIds.forEach(variantId => {
      formData.items.push({
        id: variantId,
        quantity: 1
      });
    })

    const fetchRes = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const fetchResJson = await fetchRes.json();
    if(fetchRes.status != 200) {
      const message = fetchResJson.description || fetchResJson.message || 'Das Produkt konnte leider nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es erneut.';
      alert(message);
    } else {
      window.location.href = "/cart";
    }

  }
}

customElements.define('vuv-configurator', VUVConfigurator);
